import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=3139b405&scoped=true"
import script from "./chat.vue?vue&type=script&lang=js"
export * from "./chat.vue?vue&type=script&lang=js"
import style0 from "./chat.vue?vue&type=style&index=0&id=3139b405&prod&lang=stylus&scoped=true"
import style1 from "../../../static/css/chat.css?vue&type=style&index=1&id=3139b405&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3139b405",
  null
  
)

export default component.exports